var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"ml-2",attrs:{"color":"lightNeutral","rounded":""},on:{"click":function($event){return _vm.pushProfilePage()}}},[_vm._v(" الملف الشخصي")])}
var staticRenderFns = []

export { render, staticRenderFns }